import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function WhatYouGet() {
  const includes = ['Der 3‑Zonen‑Check (Nase / Mund‑Rachen / Position)', '14‑Nächte‑Plan (Baseline → Fokus‑Tests → Kombi)', 'Tracker (druckbar + digital)', 'Entscheidungsbaum: DIY vs. Abklärung (Warnzeichen klar benannt)', 'Partner‑Protokoll (kurz): 3 Sätze, die das Thema entschärfen'];
  const excludes = ['keine Wunderversprechen', 'kein "Du musst nur diszipliniert sein"', 'kein 60‑Minuten-Abendritual, das kein normaler Mensch durchzieht'];
  return <section className="w-full bg-[#1e293b] py-24 px-4 md:px-6" data-id="element-176">
      <div className="max-w-4xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-177">
        {/* What you get */}
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-178">
          <h3 className="text-2xl font-bold text-[#faf5ef] mb-8 flex items-center" data-id="element-179">
            <span className="bg-[#d4a574] w-8 h-1 mr-4 rounded-full" data-id="element-180"></span>
            Was du bekommst
          </h3>
          <ul className="space-y-6" data-id="element-181">
            {includes.map((item, i) => <li key={i} className="flex items-start" data-id="element-182">
                <div className="bg-[#d4a574]/20 p-1 rounded-full mr-4 mt-0.5 flex-shrink-0" data-id="element-183">
                  <Check className="w-4 h-4 text-[#d4a574]" data-id="element-184" />
                </div>
                <span className="text-[#cbd5e1] leading-snug" data-id="element-185">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        {/* What you DON'T get */}
        <motion.div initial={{
        opacity: 0,
        x: 30
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-[#0f172a] p-8 rounded-2xl border border-[#334155]" data-id="element-186">
          <h3 className="text-xl font-bold text-[#94a3b8] mb-6 uppercase tracking-wider text-sm" data-id="element-187">
            Was du NICHT bekommst
          </h3>
          <ul className="space-y-4" data-id="element-188">
            {excludes.map((item, i) => <li key={i} className="flex items-start opacity-75" data-id="element-189">
                <X className="w-5 h-5 text-red-400 mr-3 mt-0.5 flex-shrink-0" data-id="element-190" />
                <span className="text-[#94a3b8]" data-id="element-191">{item}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}